import gql from 'graphql-tag';
import FieldsBooking from "graphql/fields/FieldsBooking";
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsJobtitle from "graphql/fields/FieldsJobtitle";
import HelperGraphql from 'utils/helper-graphql'
import FieldsTranslation from 'graphql/fields/FieldsTranslation'
import FieldsTimeslotKindLimitation from 'graphql/fields/FieldsTimeslotKindLimitation'

const fields = {
	'building_guid': 'String',
	'booking_date': '[String]',
	'status': '[String]',
};

export default gql(`
	query employee_bookings( ${ HelperGraphql.createFields( fields ) } ) {
		employee_bookings( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsBooking}
			license_plate
			
			license_plate_item {
				id
				license_plate
				car_type
				car_fuel_type
				car_length
				car_width
				car_height
				car_wheelbase
				car_weight
				validated
			}
			
			building {
				guid
			}
			
			timeslot {
				guid
				timeslot_start
				timeslot_end
				kind
				
				timeslot_kind {
					guid
					name
					kind
					sub_kind
					
					translations {
						${FieldsTranslation}
					}
					
					limitation {
						${ FieldsTimeslotKindLimitation }
					}
				}
			}
			
			employee {
				${FieldsEmployee}
				kind
				
				department {
					${FieldsDepartment}
				}
				
				jobtitle {
					${FieldsJobtitle}
				}
			}
		}
	}
`);

